const reducerPaths = {
  appConfiguration: "appConfiguration",
  auth: "auth",
  alertDialog: "alertDialog",
  myGarage: "myGarage",
  sellMyCarDashboard: "sellMyCarDashboard",
  sidebar: "sidebar",
  liveAuction: "liveAuction",
  carsInNegotiation: "carsInNegotiation",
  currencySlice: "currencySlice",
  signinApi: "signinApi",
  vehicleApi: "vehicleApi",
  myGarageApi: "myGarageApi",
  buyNowApi: "buyNowApi",
  liveAuctionApi: "liveAuctionApi",
  carEstimateSlice: "carEstimateSlice",
  carEstimateApi: "carEstimateApi",
  upcomingCarsApi: "upcomingCarsApi",
  carDetailsApi: "carDetailsApi",
  carsInNegotiationApi: "carsInNegotiationApi",
  contactUsApi: "contactUsApi",
  geographyApi: "geographyApi",
  paypalApi: "paypalApi",
  walletAndPaymentsApi: "walletAndPaymentsApi",
  paymentsApi: "paymentsApi",
  subAccountApi: "subAccountApi",
  currencyApi: "currencyApi",
  carfaxApi: "carfaxApi",
  appConfigurationApi: "appConfigurationApi",
  myOrdersApi: "myOrdersApi"
};

export { reducerPaths };
